import React, { Component } from 'react'

import Button from '../button'
import Icon from '../icon'

import './circleButton.scss'
class CircleButton extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    if (this.props.icon === null || this.props.icon === undefined) return null
    let buttonProps = { ...this.props, round: true }

    return (
      <div className='element-circlebutton'>
        <Button {...buttonProps}>
          <Icon size={this.props.size} icon={this.props.icon} injectSvg />
        </Button>
      </div>
    )
  }
}

CircleButton.defaultProps = {
  size: 'l',
  style: 'link',
  // round: true,
  spacing: 0
}

export default CircleButton



// WEBPACK FOOTER //
// ./src/app/shared/elements/circleButton/index.js